import React from 'react';
import blogCover from '../images/b4.png';
import blogCover2 from '../images/news5.jpeg';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';

import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/fintech-web-app-development"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function FintechWebAppDevelopment() {

    const postDate = "July 26, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            Fintech Web App Development with Peregrinee
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Discover how Peregrinee develops secure fintech web applications
                        with advanced data protection, compliance readiness,
                        and high-performance financial systems.
                    </p>

                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>


            {/* HERO IMAGE */}
            <section className="container mb-5">

                <img
                    src={blogCover}
                    alt="Fintech Web Application Development"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />

            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">

                        <img
                            src={blogCover}
                            alt="Fintech Application Architecture"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            The Rise of Fintech Web Applications
                        </h3>

                        <p>
                            Fintech platforms are transforming how businesses
                            and individuals manage financial transactions,
                            payments, investments, and digital banking.
                        </p>

                        <p>
                            Modern fintech systems require secure,
                            high-performance architectures capable of
                            processing sensitive financial data while
                            maintaining strict compliance with industry
                            regulations.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Core Fintech Capabilities
                        </h3>

                        <ul className="ps-3">
                            <li>Digital payments and transaction processing</li>
                            <li>Financial analytics and reporting</li>
                            <li>Secure account management</li>
                            <li>Real-time financial data processing</li>
                            <li>API integrations with banking systems</li>
                        </ul>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            Security and Compliance in Fintech Development
                        </h3>

                        <p>
                            Security is one of the most critical aspects
                            of fintech web applications. Financial platforms
                            must protect sensitive user data and comply
                            with strict regulatory standards.
                        </p>

                        <ul className="ps-3">
                            <li>Advanced encryption protocols</li>
                            <li>Secure authentication systems</li>
                            <li>Compliance with financial regulations</li>
                            <li>Fraud detection and monitoring</li>
                            <li>Secure payment gateway integrations</li>
                        </ul>

                        <p className="mt-3">
                            Peregrinee ensures that fintech platforms
                            are built with security-first architecture.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Start Your Fintech Project
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="Secure Fintech Infrastructure"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* SECTION 3 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Essential Features of Fintech Platforms
                </h2>

                <ul className="ps-3">
                    <li>Secure user authentication</li>
                    <li>Transaction monitoring and logs</li>
                    <li>Financial reporting dashboards</li>
                    <li>Payment gateway integrations</li>
                    <li>Data encryption and compliance tools</li>
                </ul>

                <p className="mt-3">
                    These features help fintech platforms deliver reliable,
                    secure financial services to users.
                </p>

            </section>


            {/* SECTION 4 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Technologies Used for Fintech Development
                </h2>

                <ul className="ps-3">
                    <li>Secure backend services with Node.js</li>
                    <li>Modern frontend frameworks like React</li>
                    <li>Cloud infrastructure for scalability</li>
                    <li>Encrypted databases</li>
                    <li>API integrations with financial institutions</li>
                </ul>

                <p className="mt-3">
                    Peregrinee carefully selects technologies to ensure
                    fintech platforms remain secure, scalable,
                    and high-performing.
                </p>

            </section>


            {/* SECTION 5 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Building the Future of Digital Finance
                </h2>

                <p>
                    Fintech innovation continues to reshape the global
                    financial ecosystem. Businesses require secure,
                    scalable platforms capable of handling financial
                    transactions with precision and reliability.
                </p>

                <p>
                    Peregrinee focuses on building fintech applications
                    that combine strong security practices,
                    scalable infrastructure, and modern user experiences.
                </p>

                <div className="text-center mt-4">

                    <a
                        href="/contact-us"
                        className="btn btn-orange rounded-pill px-5 py-3 fw-bold"
                        style={{ width: "fit-content" }}
                    >
                        Build Your Fintech Web Application
                    </a>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default FintechWebAppDevelopment;